import { Action, State, StateContext } from '@ngxs/store';

import { CorporateMatching } from './corporate-matching.model';
import * as CorporateActions from './corporate-matching.actions';
import { CorporateAPIService } from '../../api/corporate-api.service';
import { pluck, map } from 'rxjs/operators';
import { GaClient } from '../../../init';

@State<CorporateMatching>({
  name: 'corporateMatching',
  defaults: new CorporateMatching()
})
export class CorporateMatchingState {
  constructor(private lookupAPI: CorporateAPIService) {}

  @Action(CorporateActions.SearchCorporate)
  searchCorporate(
    { getState, setState }: StateContext<CorporateMatching>,
    { payload }: CorporateActions.SearchCorporate
  ) {
    const state = getState();
    this.lookupAPI
      .getCorporate(payload)
      .pipe(
        pluck('result'),
        pluck('items'),
        map((items: any) =>
          items.map(item => {
            return { text: item.name, val: item.id };
          })
        )
      )
      .subscribe(corporations => {
        setState({ selected: state.selected, corporateSearch: corporations });
      });
  }

  @Action(CorporateActions.SetCorporate)
  setCorporateMatching(
    { getState, setState }: StateContext<CorporateMatching>,
    { payload }: CorporateActions.SetCorporate
  ) {
    const state = getState();
    setState({ selected: payload, corporateSearch: state.corporateSearch });
    GaClient.trackSelection();
  }
}
